module.exports = {
	"id": "CY",
	"name": "Cyprus",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": 0.00613,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": 0.01226,
			"12": null,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": 0.01226,
			"18": null,
			"19": 0.00613,
			"20": null,
			"21": 0.00613,
			"22": 0.03678,
			"23": 0.01226,
			"24": null,
			"25": null,
			"26": 0.01839,
			"27": 0.00613,
			"28": 0.00613,
			"29": 0.01226,
			"30": 0.02452,
			"31": 0.01839,
			"32": 0.01226,
			"33": 0.01839,
			"34": 0.01839,
			"35": 0.02452,
			"36": 0.01226,
			"37": 0.03065,
			"38": 0.05517,
			"39": 0.06743,
			"40": 0.01226,
			"41": 0.03065,
			"42": 0.6743,
			"43": 0.15325,
			"44": 0.07356,
			"45": 0.01839,
			"46": 0.03678,
			"47": 0.06743,
			"48": 0.06743,
			"49": 2.85658,
			"50": 0.11647,
			"51": 0.96854,
			"52": 0.4291,
			"53": 26.46934,
			"54": 6.88399,
			"55": 0.06743,
			"56": 0.01839,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": 0.00613,
			"4": 0.00613,
			"5": 0.00613,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": null,
			"12": 0.01226,
			"13": null,
			"14": null,
			"15": null,
			"16": 0.02452,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": 0.09808,
			"27": null,
			"28": null,
			"29": null,
			"30": null,
			"31": null,
			"32": null,
			"33": 0.00613,
			"34": null,
			"35": 0.00613,
			"36": 0.01839,
			"37": 0.00613,
			"38": 0.04291,
			"39": 0.02452,
			"40": 0.00613,
			"41": 0.01226,
			"42": 0.02452,
			"43": 0.09808,
			"44": 0.02452,
			"45": 0.08582,
			"46": 0.06743,
			"47": 0.39845,
			"48": 0.3678,
			"49": 6.54071,
			"50": 0.07356,
			"51": null,
			"52": null,
			"3.5": null,
			"3.6": 0.03065
		},
		"opera": {
			"9": null,
			"11": null,
			"12": 0.01226,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": 0.00613,
			"25": null,
			"26": null,
			"27": 0.01226,
			"28": null,
			"29": null,
			"30": null,
			"31": null,
			"32": null,
			"33": null,
			"34": null,
			"35": null,
			"36": 0.01226,
			"37": 0.02452,
			"38": 0.0613,
			"39": 0.00613,
			"40": 0.41684,
			"41": 0.07356,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": null,
			"12.1": 0.0613
		},
		"safari": {
			"0": null,
			"4": 0.00613,
			"5": 0.04904,
			"6": 0.00613,
			"7": 0.04291,
			"8": 0.11647,
			"9": 0.15325,
			"10": 1.14631,
			"3.1": null,
			"3.2": null,
			"5.1": 0.11647,
			"6.1": 0.06743,
			"7.1": 0.01226,
			"9.1": 0.69269
		},
		"ios_saf": {
			"8": 0,
			"10": 5.5370741965,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.149217742506,
			"8.1-8.4": 0.275673456495,
			"9.0-9.2": 0.131513942548,
			"9.3": 2.00643066195
		},
		"android": {
			"3": 0,
			"4": 0.04256,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.00532,
			"4.1": 0.15352,
			"4.2-4.3": 0.3838,
			"4.4": 0.88008,
			"4.4.3-4.4.4": 0.88768
		},
		"ie": {
			"6": null,
			"7": 0.0247897469747,
			"8": 1.06595911991,
			"9": 0.198317975798,
			"10": 0.167330792079,
			"11": 4.17707236524,
			"5.5": null
		},
		"op_mob": {
			"0": 0.0226852621497,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.000630146170824
		},
		"edge": {
			"12": 0.07356,
			"13": 0.47201,
			"14": 1.43442
		},
		"ie_mob": {
			"10": 0.0679157746479,
			"11": 0.276514225352
		},
		"bb": {
			"7": 0.0125775,
			"10": null
		},
		"samsung": {
			"0": 4.46598
		},
		"and_uc": {
			"0": 1.73763
		},
		"op_mini": {
			"0": 0.30563459168
		},
		"and_chr": {
			"0": 22.49397
		},
		"and_ff": {
			"0": 0.01548
		}
	},
	"total": 97.9091175
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/CY.json
 ** module id = 504
 ** module chunks = 0
 **/